// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/mlmOrg/SponsorViewDialog.js

import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { API_URLS } from '../../api/api';
import { getSelectedLanguage } from '../../api/api';        // NEW
import { languageManager } from '../../utils/loadLanguage'; // NEW

const SponsorViewDialog = ({ visible, onHide, userId }) => {
    const [sponsorData, setSponsorData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // State สำหรับข้อความจาก JSON ภายใต้ orgChartComponent
    const [t, setT] = useState({});

    // โหลดภาษา
    useEffect(() => {
        async function loadLang() {
            const lang = getSelectedLanguage(); // e.g. 'en' or 'th'
            await languageManager.loadLanguage(lang);
            setT(languageManager.translations.orgChartComponent || {});
        }
        loadLang();
    }, []);

    useEffect(() => {
        if (visible && userId) {
            fetchSponsorData(userId);
        }
    }, [visible, userId]);

    const fetchSponsorData = async (uId) => {
        setLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(API_URLS.SPONSOR_VIEW(uId), {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch sponsor data');
            }

            const data = await response.json();
            // สมมติ data เป็น array => setSponsorData(data[0])
            if (Array.isArray(data) && data.length > 0) {
                setSponsorData(data[0]);
            } else {
                setSponsorData(null);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const dialogFooter = (
        <div style={{ textAlign: 'right' }}>
            <Button
                label="Close"
                className="p-button-text p-button-secondary"
                onClick={onHide}
            />
        </div>
    );

    const renderProfile = () => {
        if (!sponsorData) return null;

        return (
            <div className="p-fluid">
                <h3>{t.profileDetailsTitle || "Profile Details"}</h3>
                <div className="field">
                    <label><strong>{t.commissionLabel || "Commission"}:</strong></label>
                    <p>{sponsorData.commission_rate}</p>
                </div>
                <div className="field">
                    <label><strong>{t.registerDateLabel || "Register Date"}:</strong></label>
                    <p>{sponsorData.join_date}</p>
                </div>
                <div className="field">
                    <label><strong>{t.positionLabel || "Position"}:</strong></label>
                    <p>{sponsorData.position_Name}</p>
                </div>
                <div className="field">
                    <label><strong>{t.teamNameLabel || "Team Name"}:</strong></label>
                    <p>{sponsorData.team_id}</p>
                </div>

              
                <h3>{t.sponsorTitle || "Sponsor (แม่ทีม)"}</h3>
                <div className="field">
                    <label><strong>{t.userIDLabel || "User ID"}:</strong></label>
                    <p>{sponsorData.user_id}</p>
                </div>
                <div className="field">
                    <label><strong>{t.nameLabel || "Name"}:</strong></label>
                    <p>{sponsorData.sponsor_first_name}</p>
                </div>
                <div className="field">
                    <label><strong>{t.lastLabel || "Last"}:</strong></label>
                    <p>{sponsorData.sponsor_sur_name}</p>
                </div>
                <div className="field">
                    <label><strong>{t.emailLabel || "Email"}:</strong></label>
                    <p>{sponsorData.email || 'N/A'}</p>
                </div>
                <div className="field">
                    <label><strong>{t.socialMediaLabel || "Social Media"}:</strong></label>
                    <p>{sponsorData.ssSocialMedia || 'N/A'}</p>
                </div>
                <div className="field">
                    <label><strong>{t.telLabel || "Tel"}:</strong></label>
                    <p>{sponsorData.ssTelephone || 'N/A'}</p>
                </div>

                <h3>{t.subordinateTitle || "Subordinate (ลูกทีม)"}</h3>
                <div className="field">
                    <label><strong>{t.sponsorUserID || "Sponsor User ID"}:</strong></label>
                    <p>{sponsorData.ssUserID}</p>
                </div>
                <div className="field">
                    <label><strong>{t.sponsorName || "Sponsor Name"}:</strong></label>
                    <p>{sponsorData.user_first_name}</p>
                </div>
                <div className="field">
                    <label><strong>{t.sponsorLast || "Sponsor Last"}:</strong></label>
                    <p>{sponsorData.user_sur_name}</p>
                </div>
                <div className="field">
                    <label><strong>{t.sponsorTel || "Sponsor Tel"}:</strong></label>
                    <p>{sponsorData.Telephone || 'N/A'}</p>
                </div>
            </div>
        );
    };

    return (
        <Dialog
            header={`${t.sponsorProfileHeader || "Sponsor Profile"} - User ID: ${userId}`}
            visible={visible}
            style={{ width: '40vw' }}
            onHide={onHide}
            footer={dialogFooter}
        >
            {loading && <div>{t.loading || "LOADING..."}</div>}
            {error && <div style={{ color: 'red' }}>{error}</div>}

            {(!loading && sponsorData) && renderProfile()}
        </Dialog>
    );
};

export default SponsorViewDialog;
